function sessionIsCheck() {
    if(localStorage.getItem("campaigndetails") === null ||
    localStorage.getItem("apinfo") === null ||
    localStorage.getItem("process") === null ||
    localStorage.getItem("extension") === null ||
    localStorage.getItem("selectedCampaign_data") === null){
        return false
    }else{
        return true
    }
}

export { sessionIsCheck }